<script>
import { ref } from 'vue';
import IconSvg from './IconSvg';
import { ICONS, TYPES } from '../config/constants';
const isHttps = window.location.protocol === 'https:';
import MessageCardBase from '@/components/message-card-base';

const getStrCharCodeLen = (str) => {
  let len = 0;
  for (let i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 127 || +str.charCodeAt(i) === 94) {
      len += 2;
    } else {
      len++;
    }
  }
  return len;
};
const Props = {
  title: {
    type: String,
    default: '',
  },
  datetime: {
    type: String,
    default: '',
  },
  content: {
    type: String,
    default: '',
  },
  module: {
    type: String,
    default: '',
  },
  contentImages: {
    type: Array,
    default: () => {
      return [];
    },
  },
  images: {
    type: Array,
    default: () => {
      return [
        // {
        //   'urlHttps': 'https://img0.didiglobal.com/static/soda_public/do1_aNMJAqpATiUb7zLRhaXU',
        //   'url': 'http://img0.didiglobal.com/static/soda_public/do1_aNMJAqpATiUb7zLRhaXU',
        //   'key': 'do1_aNMJAqpATiUb7zLRhaXU'
        // }
      ];
    },
  },
  link: {
    type: String,
    default: '',
  },
  linkText: {
    type: String,
    default: '',
  },
  unRead: {
    type: Boolean,
    default: false,
  },
  msgType: {
    type: Number,
    default: 1,
  },
};
export default {
  components: { IconSvg, MessageCardBase },
  props: Props,
  setup() {
    const isSeeAll = ref(false);
    return {
      rightIcon: require('../static/right.svg'),
      ellipsis: true,
      isSeeAll: isSeeAll,
      putSeeAll() {
        isSeeAll.value = !isSeeAll.value;
      },
      getLastModuleName(module = '') {
        const getLast = (list) => {
          if (list.length === 0) return null;
          return list.pop() || getLast(temps);
        };
        const temps = module.split('>') || [];
        return getLast(temps);
      },
    };
  },
  methods: {
    goLink() {
      if (!this.link) return;
      window.open(this.link);
    },
  },
  render(_) {
    const currentIcon = ICONS[TYPES[this.msgType]] || ICONS[TYPES[1]];
    return (
      <div class="notifications-card">
        <div class="notifications-card-left">
          {this.unRead ? <i class="notifications-card-un-read" /> : null}
          <span class="notifications-card-left-image">
            <div style={{ background: currentIcon.color }} />
            <icon-svg
              type={currentIcon.icon}
              styles={{
                width: '16px',
                height: '16px',
                fill: currentIcon.color,
                opacity: 1,
              }}
            />
          </span>
        </div>
        <MessageCardBase
          props={{
            title: this.title,
            images: this.images,
            contentImages: this.contentImages,
            link: this.link,
            unRead: this.unRead,
            msgType: this.msgType,
            module: this.module,
            datetime: this.datetime,
            content: this.content,
            linkText: this.linkText,
          }}
        />
      </div>
    );
  },
};
</script>
<style lang="scss" scoped>
@import '../common.ignore';

$prefix: 'notifications-card';
@mixin notifications($fix) {
  $p: $prefix + '-' + $fix;
  .#{$p} {
    @content;
  }
}

.#{$prefix} {
  margin-bottom: 24px;
  font-family: DiDiSans-Pro-Regular, serif;
  display: flex;
  @include notifications(left) {
    position: relative;
    width: 40px;
    padding-top: 8px;
    i.notifications-card-un-read {
      position: absolute;
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #f93c32;
      border-radius: 4px;
      border: 1px solid #fff;
      top: 8px;
      right: 8px;
    }
    @include notifications(left-image) {
      position: relative;
      display: inline-block;
      border-radius: 16px;
      width: 32px;
      height: 32px;
      text-align: center;
      line-height: 27px;
      overflow: hidden;
      > div {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0.15;
        top: 0;
        left: 0;
      }
    }
  }
}
</style>
